// Vercel Base-Url
export const BASE_URL = "https://eduverse-backend-nine.vercel.app/api/";

// local  Base-Url
//  export const BASE_URL =  "http://localhost:8000/api/";


 // Production AWS  Base-Url
//  export const BASE_URL =  "http://13.213.28.207:7000/api/";

 
